import { createAsyncThunk } from '@reduxjs/toolkit';
import { callGetAuditLogs } from 'helpers/audit_log_helper';

export const getAuditLogs = createAsyncThunk(
  'auditLogs/getAuditLogs',
  async (params: any, { rejectWithValue }) => {
    try {
      const response: any = await callGetAuditLogs(params);
      const responseData = response.data;
      const isCursorResponse = responseData && !Array.isArray(responseData);

      return {
        data: isCursorResponse ? responseData.items || [] : responseData || [],
        nextCursor: isCursorResponse ? responseData.nextCursor : undefined,
        hasMore: isCursorResponse ? Boolean(responseData.hasMore) : false,
        append: Boolean(params?.cursor),
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
